import type { SVGProps } from 'react';
const SvgScatterPlot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#scatter_plot_svg__a)">
      <path d="M7 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM11 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM16.6 20.6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
    </g>
    <defs>
      <clipPath id="scatter_plot_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgScatterPlot;
